import React from "react";
import { defaultProfile } from "components/pages/talents/talentListNew/helper";
import { StarFilled } from "@ant-design/icons";

const baseUrl = process.env.REACT_APP_API_URL;

const COLORS = {
  confirm: {
    keywordColor: "darkMintGreen",
    defaultHeaderPrefix: "Do you really want to",
    defaultBtn: "Yes, confirm",
    btnClass: "bg-richBlue text-white shadow-button border border-transparent",
  },

  deny: {
    keywordColor: "formWarning",
    defaultHeaderPrefix: "Do you really want to",
    defaultBtn: "Yes, deny",
    btnClass: "bg-white text-formWarning border border-formWarning shadow-button",
  },

  "fully staffed": {
    keywordColor: "darkMintGreen",
    defaultHeaderPrefix: "This shift is already ",
    defaultBtn: "Yes, confirm",
    btnClass: "bg-richBlue text-white shadow-button border border-transparent",
  }
};

const PopupModal = ({
  open,
  variant = "confirm",
  talent = {},
  onPrimary,
  onCancel,
}) => {
  if (!open) return null;

  const theme = COLORS[variant];

  const imageStyle = "w-[32px] min-w-[32px] max-w-[32px] h-[40px] rounded-[6px]";

  const { name, rating, photo, shift, duties } = talent
  
  const handleBackdropClick = () => {
    if (onCancel) onCancel();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/20"
        onClick={handleBackdropClick}
      />

      <div className="
        relative inline-flex flex-col items-end p-6
        rounded-[8px] border border-richBlue/80 bg-white shadow-modal z-50
      ">
        <div className="border rounded-lg border-cadetGray/50 w-[609.62px]">
          <div className="flex flex-col items-center py-[10px] w-full bg-white rounded-lg">
            <h3 className="text-sm font-bold text-center text-fontGray">
              {theme.defaultHeaderPrefix}{" "}
              <span className={`uppercase text-${theme.keywordColor}`}>{variant}</span>
              {variant === 'fully staffed' ?
                `. Approve ${talent?.name} anyway?` :
                ` ${talent?.name} for this shift and role?`
              }
            </h3>
          </div>

          <div className="flex items-start p-[10px] gap-4 bg-catskill w-full h-full rounded-lg jus">
            <div className="flex gap-4">
              <img
                className={imageStyle}
                src={photo}
                onError={(e) => (e.target.src = defaultProfile)}
                alt="profile"
              />
              <h2 className="text-subHeader font-medium text-grayBlack flex items-center justify-center">{name}</h2>
              <div className="w-[10%] text-subText flex items-center gap-2">
                <StarFilled className="text-darkMintGreen" /> {rating}
              </div>
            </div>
            <div className="flex flex-col">
              <h2 className="text-policeBlue text-sm font-medium">{shift?.name}</h2>
              <p className="text-pastelGray text-xs">From: {shift?.from}</p>
              <p className="text-pastelGray text-xs">To: {shift?.to}</p>
            </div>
            {duties && <div className="flex">
              <h2 className="text-policeBlue text-sm font-medium">{duties}</h2>
            </div>}
          </div>
        </div>

        <div className="flex gap-3 mt-3">
          <button
            onClick={onPrimary}
            className={`
              flex items-center gap-[10px] h-8 px-3 py-1.5
              rounded-lg text-sm ${theme.btnClass}
            `}
          >
            {theme.defaultBtn}
          </button>

          <button
            onClick={onCancel}
            className="
              flex items-center gap-[10px] h-8 px-3 py-1.5 rounded-lg text-sm border
              border-cadetGray/80 bg-white shadow-button text-fontGray
            "
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
